import LoadingIndicator from "react-loading-indicator";
import styled from "styled-components";

export const ChannelIcon = styled.img`
  width: ${({ size = 25 }) => size}px;
  height: ${({ size = 25 }) => size}px;
  margin-left: ${({ ml = 0 }) => ml}px;
  margin-right: 8px;
  filter: grayscale(100%);
  opacity: 0.5;
  transition: all 0.2s;
`;

export const ChannelWrapper = styled.div`
  position: relative;
  margin: 4px 0;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ChannelMain = styled.div`
  background: transparent;
  color: #8e8fa3;
  width: 100%;
  border-radius: 4px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 6px 12px 12px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  ${({ active, theme }) =>
    active
      ? `
      background: ${theme?.colors?.bg || "#FFF"};
      color: #1E1F46;
      ${ChannelIcon} {
        opacity: 1;
        filter: none;
      }
    `
      : `
      &:hover {
        background-color: ${theme?.colors?.bg__light || "#1e1f4610"};
      };
    `}
`;

export const ChannelSelectorWrapper = styled.div`
  min-width: 180px;
  width: fit-content;
`;

export const PageLink = styled.a`
  display: flex;
  border-radius: 100%;
  padding: 2px;
  margin-left: 20px;
  transition: all 0.2s;
  background-color: #dedede;
  color: inherit;
  &:hover {
    color: #1e22ff;
    background-color: #e9e9ff;
    box-shadow: 0px 2px 4px 0px #1516331f;
  }
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ChannelActions = styled.div`
  display: flex;
  align-items: center;
`;

export const Loader = styled(LoadingIndicator)`
  display: flex;
  width: 20px;
  height: 20px;
  margin-left: 20px;
`;

export const Menu = styled.div`
  position: absolute;
  right: 6px;
  padding: 12px 0;
  background: #e9e9ff;
  border-radius: 4px 0 4px 4px;
  z-index: 1;
  top: 34px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  transition: all 0.2s;
  ${({ show }) =>
    show
      ? `
    opacity: 1;
    visibility: visible;
  `
      : `
    opacity: 0;
    visibility: hidden;
  `}
`;

export const MenuItem = styled.div`
  padding: 4px 20px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    color: #1e22ff;
  }
`;

export const SidebarChannelsText = styled.div`
  font-family: Public Sans;
  font-size: 18px;
  font-weight: 700;
  line-height: ${({ lineHeight }) => lineHeight ?? "40px"};
  letter-spacing: 0em;
  text-align: left;
  color: #5f5c70;
`;

export const SingleSidebarSection = styled.div`
  margin-bottom: 30px;
`;
